import { Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import {
  OrderPreviewCancelCommand, OrderPreviewCancelCommandResult, OrderPreviewCheckoutCommand,
  OrderPreviewCheckoutCommandResult, OrderPreviewClient, OrderPreviewGetQuery, OrderPreviewGetQueryResult
} from "../../INTEGRA_Shop_Client";
import { IOrderPreviewApiService, IOrderPreviewApiServiceToken } from "./order-preview-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class OrderPreviewApiService implements IOrderPreviewApiService {

  constructor(
    private orderPreviewClient: OrderPreviewClient,
  ) { }

  public orderPreviewGet(
    cartNumber: number,
    validateCart: boolean | undefined = true,
    belegDidToAdd?: string[] | undefined
  ): Observable<OrderPreviewGetQueryResult> {
    let query = new OrderPreviewGetQuery({
      cartNumber: cartNumber,
      validateCart: validateCart,
      belegDidToAdd: belegDidToAdd
    });
    return this.orderPreviewClient.orderPreviewGet(query);
  }

  public orderPreviewCheckout(
    cartNumber: number,
    belegDidToAdd?: string[] | undefined,
    sendConfirmationCopyToCustomer?: boolean,
    contactCustomer?: boolean | undefined,
    contactCustomerText?: string | undefined
  ): Observable<OrderPreviewCheckoutCommandResult> {
    let command = new OrderPreviewCheckoutCommand({
      cartNumber: cartNumber,
      belegDidToAdd: belegDidToAdd,
      sendConfirmationCopyToCustomer: sendConfirmationCopyToCustomer,
      contactCustomer: contactCustomer,
      contactCustomerText: contactCustomerText
    });
    return this.orderPreviewClient.orderPreviewCheckout(command);
  }

  public orderPreviewCancel(shoppingCartNumber: number, belegDidToAdd?: string[] | undefined): Observable<OrderPreviewCancelCommandResult> {
    let command = new OrderPreviewCancelCommand({
      shoppingCartNumber: shoppingCartNumber,
      belegDidToAdd: belegDidToAdd
    });
    return this.orderPreviewClient.orderPreviewCancel(command);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OrderPreviewApiServiceProvider: Provider[] = [
  { provide: OrderPreviewClient },
  { provide: IOrderPreviewApiServiceToken, useExisting: OrderPreviewApiService }
];
